import { gql } from '@apollo/client';

export const GET_WORK_PROGRESS_BAG_CUSTOMER_SUMMARY_PAGE = gql`
  query GetWorkProgressBagCustomerSummaryPage($filter: WorkProgressBagCustomerSummaryFilterInput!) {
    getWorkProgressBagCustomerSummaryPage(filter: $filter) {
      content {
        customerId
        customerName
        onlyNoMawbBreakdownRows
        expectedBagCountSum
        inboundBagCountSum
        bagDiffSum
        bagDiffRate
        expectedParcelCountSum
        inboundParcelCountSum
        parcelDiffSum
        parcelDiffRate
      }
      aggregate {
        expectedBagCountSum
        inboundBagCountSum
        bagDiffSum
        bagDiffRate
        expectedParcelCountSum
        inboundParcelCountSum
        parcelDiffSum
        parcelDiffRate
      }
      allCustomers {
        customerId
        customerName
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
      dataCalculatedAtMax
    }
  }
`;

export interface WorkProgressBagSummaryAggregate {
  expectedBagCountSum: number;
  inboundBagCountSum: number;
  bagDiffSum: number;
  bagDiffRate: number;
  expectedParcelCountSum: number;
  inboundParcelCountSum: number;
  parcelDiffSum: number;
  parcelDiffRate: number;
}

export interface WorkProgressBagCustomerSummaryRow {
  customerId: number;
  customerName: string;
  /** 与二级展开一致：仅有无提单号汇总、无有提单号时主表预期大包数展示「-」 */
  onlyNoMawbBreakdownRows?: boolean;
  expectedBagCountSum: number;
  inboundBagCountSum: number;
  bagDiffSum: number;
  bagDiffRate: number;
  expectedParcelCountSum: number;
  inboundParcelCountSum: number;
  parcelDiffSum: number;
  parcelDiffRate: number;
}

export interface WorkProgressBagCustomerOption {
  customerId: number;
  customerName: string;
}

export interface GetWorkProgressBagCustomerSummaryPageResponse {
  getWorkProgressBagCustomerSummaryPage: {
    content: WorkProgressBagCustomerSummaryRow[];
    aggregate: WorkProgressBagSummaryAggregate;
    allCustomers: WorkProgressBagCustomerOption[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
    /** ISO-8601 数据计算时间（calculated_at）最大值，无数据时为 null */
    dataCalculatedAtMax?: string | null;
  };
}

export interface WorkProgressBagCustomerSummaryFilterInput {
  hubId: number;
  arrivalDateStart?: string | null;
  arrivalDateEnd?: string | null;
  customerId?: number | null;
  /** true：当前大包预实差口径；false：包裹差异仅统计已入库大包 */
  showBagExpectedDiff?: boolean | null;
  page?: number;
  pageSize?: number;
  sortField?: 'PARCEL_DIFF' | 'EXPECTED_PARCEL_COUNT' | 'INBOUND_PARCEL_COUNT' | null;
  sortDirection?: 'ASC' | 'DESC' | null;
}

